import React from 'react'
import customRequest from '../../../helpers/customRequest'
import message from '../../../components/message/message'
import initializeLocations from '../../../helpers/forms/location-form'
import { initializeFormValidation } from '../../../helpers/forms/form-validation'
import ClipLoader from 'react-spinners/ClipLoader'

class Password extends React.Component
{
    state = {
        submitting: false
    }
    componentDidMount()
    {
        initializeLocations()
		initializeFormValidation(this.onSubmit)
    }

    onSubmit = () => {
        this.setState({submitting: true}, () => {
            customRequest.post('/api/account/change-password', {
                "currentPassword": document.getElementById("current-password").value,
                "newPassword": document.getElementById("password").value
            })
            .then(({data}) => {
                message.clear()
                this.setState({submitting: false})
                if (data.valid) {
                    message.success("Your password has been successfully updated.")
                    document.getElementById("current-password").value = ""
                    document.getElementById("password").value = ""
                    document.getElementById("password-confirmation").value = ""
                }
                else {
                    message.error(data.message)
                }
            })
        })
    }

    render()
    {
        return (
            <form class = "form-horizontal form-validate" noValidate method = "post">
                <div class = "form-group row">
                    <label for = "current-password" class = "d-none d-sm-inline col-sm-3 control-label text-right">Current&nbsp;Password</label>
                    
                    <div class = "col-sm-6">
                        <input type = "password" disabled={this.state.submitting} class = "form-control string" id = "current-password" name = "current-password" placeholder = "Current Password" required data-type = "current password" minlength = "5" data-description = "enter your current password" autofocus />
                    </div>
                </div>
                
                <div class = "form-group row">
                    <label for = "password"  class = "d-none d-sm-inline col-sm-3 control-label text-right">New&nbsp;Password</label>
                    
                    <div class = "col-sm-6">
                        <input type = "password" disabled={this.state.submitting} class = "form-control string" id = "password" name = "password" placeholder = "New Password" required data-type = "new password" minlength = "5" data-description = "enter your new password" />
                    </div>
                </div>
                
                <div class = "form-group row">
                    <label for = "password-confirmation" class = "d-none d-sm-inline col-sm-3 control-label text-right">Confirm&nbsp;Password</label>
                    
                    <div class = "col-sm-6">
                        <input type = "password" disabled={this.state.submitting} class = "form-control confirmation" id = "password-confirmation" name = "password-confirmation" placeholder = "Confirm Password" required data-type = "passwords" data-confirms = "password" data-description = "confirm your new password" />
                    </div>
                </div>
                
                <button type = "submit" class = "btn btn-secondary btn-lg" disabled={this.state.submitting}>{this.state.submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Change Password"}</button>
            </form>
        )
    }
}

export default Password
